import useConditionsTaxa from 'services/conditions/conditionsTaxa';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';
import { ConditionForKit } from 'types/Conditions';

import { Markdown, Typography } from 'components';

import styles from './ConditionRisk.module.css';
import { AssociatedTaxaList } from './AssociatedTaxaList';
import { AssociatedRiskFactors } from './AssociatedRiskFactors';

export const ConditionRisk = ({
  condition,
  kitId,
}: {
  condition: ConditionForKit;
  kitId: string;
}) => {
  const { currentTinyAccount } = useCurrentKitAndTinyAccount();
  // fetch the condition taxa for the current kit
  const { data: taxaData } = useConditionsTaxa();

  const taxa = taxaData ?? [];

  const associations = [...new Set(taxa?.map(t => t.association))].sort(
    (a, b) => {
      return b < a ? 1 : -1;
    },
  );

  if (!kitId || !currentTinyAccount) return null;

  return (
    <>
      {associations.length ? (
        <div className='flex flex-column gap-2'>
          <Typography variant='heading-m' className={styles.conditionTitle}>
            Microbes in this sample
          </Typography>
          <div className={styles.taxaList}>
            {associations.map(association => (
              <AssociatedTaxaList
                key={'list-' + association}
                taxa={taxa}
                condition={condition.id?.toString() || ''}
                association={association}
              />
            ))}
          </div>
        </div>
      ) : null}
      {!!condition?.decreased_risk ||
      !!condition?.increased_risk ||
      !!condition?.other_factors ? (
        <div className='flex flex-column gap-2'>
          <Typography variant='heading-m' className={styles.conditionTitle}>
            Other risk factors
          </Typography>
          <div className={styles.secondaryText}>
            {condition?.other_factors && (
              <Markdown>{condition.other_factors}</Markdown>
            )}
          </div>
          {associations.length &&
          (!!condition?.decreased_risk || !!condition?.increased_risk) ? (
            <div className={styles.taxaList}>
              {associations.map(association => (
                <AssociatedRiskFactors
                  key={'risk-' + association}
                  condition={condition}
                  association={association}
                />
              ))}
            </div>
          ) : null}
        </div>
      ) : null}
    </>
  );
};
